<template>
  <div class='cqupload'>
    <div class="content-box">
      <Upload></Upload>
    </div>
  </div>
</template>
<script>
import Upload from '@/components/Upload.vue'
export default {
  name: 'cqupload',
  data() {
    return {
      loading: false,
    }
  },
  components: {
    Upload
  },
  methods: {
  },
  created() {
    document.title = 'aqua.upload'
  }
}
</script>
<style lang='less' scoped>

.cqupload {
  display: flex;
  width: 100%;
  height: calc(100vh - 102px);
  flex-direction: column;
  align-items: center;
}

.content-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 90px;
  background-color: #fff;
  padding: 20px;
}

</style>